var $4ff2bb25c0089ffb$exports = {};
$4ff2bb25c0089ffb$exports = {
    "Empty": `Tu\u{161}\u{10D}ias`
};


export {$4ff2bb25c0089ffb$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
